import { DownOutlined } from '@ant-design/icons';
import { Button, Dropdown, Menu } from 'antd';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import allActions from '../../../../actions';
import { showNotification } from '../../../../actions/utilities/Notifications/NotificationActions';
import ConfirmModal from '../../../../components/confirmModal/ConfirmModal';
import InfoModal from '../../../../components/infoModal/InfoModal';
import PlannedOrdersContext from '../../../../contexts/plannedOrdersContext';
import SelectedItemsContext from '../../../../contexts/selectedItemsContext';
import { ACTIONTYPES } from '../../../../utils/GlobalConstants';
import CalendarModal from '../../../MaterialDetails/components/calendarModal/CalendarModal';
import { getColDataTypes } from '../../utils/MaterialListFunctions';
import styles from '../styles.module.scss';

const ActionMenu = ({
  materiallistCount,
  hasSelectedAll,
  isSelectAllMode,
  materialViewState,
  updateCallback,
  loadedItemsCount,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const user = useSelector((state) => state.authState.user);
  const dataSrc = useSelector((state) => state.commonState?.dataSrc);
  const [showPopup, setShowPopup] = useState(false);
  const [showInfoMsg, setShowInfoMsg] = useState(false);
  const [info, setInfo] = useState({
    msg: '',
    title: '',
  });
  const [dataToSend, setDataToSend] = useState({});
  const [actionMenuVisible, setActionMenuVisible] = useState(false);
  const [calenderVisible, setCalenderVisible] = useState(false);
  const [currentCalender, setCalenderObj] = useState({
    text: null,
    visible: null,
    onOK: null,
    onCancel: null,
  });
  const [showInfoModal, setShowInfoModal] = useState({ status: false });
  const { updatePlannedOrders, setMaterialViewState } = useContext(PlannedOrdersContext);

  const { selectedItems } = useContext(SelectedItemsContext);
  const materialListColumns = useSelector((state) => state.materialState.materialListColumns);

  useEffect(() => {
    if (selectedItems.length === 0 && actionMenuVisible) { setActionMenuVisible(false); }
  }, [selectedItems]);

  const handleLastChecked = (confirmed) => {
    if (selectedItems.length > 0) {
      const data = { MrpBatch: '183642', to_Mrp: [] };
      setActionMenuVisible(false);
      if (selectedItems.length <= materiallistCount?.[0]?.NoofRecords) {
        data.to_Mrp = selectedItems.map((item) => ({
          Plant: item.plantID,
          MaterialNumber: item.materialID,
          ActivateLastChecked: true,
        }));
      }
      dispatch(
        allActions.MaterialListActions.updateLastChecked(
          data,
          user.account?.username,
          user.uniqueId,
          hasSelectedAll ? 1 : 0,
          materialViewState,
          hasSelectedAll ? materiallistCount?.[0]?.NoofRecords : selectedItems.length,
          dataSrc?.matList
        ),
      );
      if (confirmed) {
        setDataToSend({});
        setShowPopup(false);
      }
    }
  };

  const handleAction = (actionType, date, confirmed) => {
    const totalRecords = materiallistCount?.[0]?.NoofRecords || 0;
    const shouldFetchAllIds = (hasSelectedAll || isSelectAllMode) && totalRecords > 50;

    if (shouldFetchAllIds) {
      // Need to fetch all items first before performing action
      const performActionWithAllItems = (allIds, sendToMrp, plants, fullListData) => {
        const itemsToProcess = filterSelectedItems(fullListData, hasSelectedAll);
        setActionMenuVisible(false);
        dispatch(
          allActions.MaterialListActions.updateActions(
            actionType,
            itemsToProcess,
            user.account?.username,
            user.uniqueId,
            date,
            hasSelectedAll ? 1 : 0,
            materialViewState,
            itemsToProcess.length,
            updateCallback,
            getColDataTypes(materialViewState.searchFilters, materialListColumns),
            dataSrc?.matList,
          ),
        );
        if (confirmed) {
          setDataToSend({});
          setShowPopup(false);
        }
      };

      dispatch(allActions.MaterialListActions.getMaterialIds(
        materialViewState,
        totalRecords,
        false,
        performActionWithAllItems,
      ));
    } else if (selectedItems.length > 0) {
      setActionMenuVisible(false);
      dispatch(

        allActions.MaterialListActions.updateActions(
          actionType,
          selectedItems,
          user.account?.username,
          user.uniqueId,
          date,
          hasSelectedAll ? 1 : 0,
          materialViewState,
          hasSelectedAll ? materiallistCount?.[0]?.NoofRecords : selectedItems.length,
          updateCallback,
          getColDataTypes(materialViewState.searchFilters, materialListColumns),
          dataSrc?.matList,
        ),
      );
      if (confirmed) {
        setDataToSend({});
        setShowPopup(false);
      }
    }
  };

  const checkIfNeedConfirmation = (actionType, date) => {
    setDataToSend({ actionType, date });
    setCalenderVisible(false);
    setActionMenuVisible(false);
    if ((hasSelectedAll && materiallistCount?.[0]?.NoofRecords > 10000)
     || selectedItems.length > 10000) {
      setShowInfoMsg(true);
      setInfo({
        msg: `No. of records selected for ${actionType} are greater than 10000. Please, limit your selection`,
        title: actionType,
      });
    } else if ((hasSelectedAll && materiallistCount?.[0]?.NoofRecords > 1000)
     || selectedItems.length > 1000) {
      setShowPopup(true);
    } else if (!materiallistCount?.[0]?.NoofRecords && hasSelectedAll) {
      setShowInfoMsg(true);
      setInfo({
        msg: `No. of records selected for ${actionType} are greater than 10000. Please, limit your selection`,
        title: actionType,
      });
    } else if (actionType === ACTIONTYPES.LastChecked) handleLastChecked(true);
    else handleAction(actionType, date);
  };

  const calenderObj = {
    [ACTIONTYPES.Postpone]: {
      text: ACTIONTYPES.Postpone,
      onOK: (date) => {
        checkIfNeedConfirmation(ACTIONTYPES.Postpone, date);
        setCalenderVisible(false);
      },
      onCancel: () => setCalenderVisible(false),
    },
    [ACTIONTYPES.Inspect]: {
      text: ACTIONTYPES.Inspect,
      onOK: (date) => {
        checkIfNeedConfirmation(ACTIONTYPES.Inspect, date);
        setCalenderVisible(false);
      },
      onCancel: () => setCalenderVisible(false),
    },
  };

  const setCurrentCalender = (name) => {
    setCalenderVisible(true);
    setActionMenuVisible(false);
    setCalenderObj(calenderObj[name]);
  };

  const compare = (a, b) => {
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0;
  };

  const copyFunction = (list, sendToMrp = false, plants = []) => {
    const sorted = list.sort(compare);
    const clipboardText = sorted.join('\r\n');
    navigator.clipboard.writeText(clipboardText);
    setActionMenuVisible(false);
    dispatch(showNotification(
      {
        Type: 'success',
        Title: 'Material Ids copied to clipboard',
      },
    ));
    if (sendToMrp) {
      const allEqual = plants.length > 0 ? plants.every((item) => item === plants[0]) : false;
      history.push({ pathname: '/mass-update', state: { ids: JSON.stringify(list), plants: allEqual ? plants[0] : '' } });
    }
  };

  const tooManyItems = (noMaxItems) => {
    if (noMaxItems) {
      return { status: false, type: '' };
    }
    if (hasSelectedAll && materiallistCount?.[0]?.NoofRecords > 500) {
      return { status: true, type: 'mrp' };
    } if (selectedItems.length > 500) return { status: true, type: 'mrp' };

    return { status: false, type: '' };
  };

  const getItemKey = (item) => {
    const plant = item.PlantID || item.PLANT_FACILITY_SAP_ID || '';
    const material = item.MaterialID || item.MATERIAL_TYPE_SAP_ID || '';
    return `${String(plant)}_${String(material)}`;
  };

  // Helper function to filter items based on selection state
  const filterSelectedItems = (fullListData, isAllSelected) => {
    const data = Array.isArray(fullListData) ? fullListData : [];

    if (isAllSelected) {
      // All items selected - return all valid items
      return data
        .filter((x) => (x.PlantID || x.PLANT_FACILITY_SAP_ID) && (x.MaterialID || x.MATERIAL_TYPE_SAP_ID))
        .map((x) => ({
          plantID: x.PlantID || x.PLANT_FACILITY_SAP_ID,
          materialID: x.MaterialID || x.MATERIAL_TYPE_SAP_ID,
        }));
    }

    // Partial selection - build deselected set from loaded items
    const selectedIdSet = new Set(
      selectedItems.map((item) => `${item.plantID}_${item.materialID}`),
    );
    const deselectedSet = new Set();
    const loadedData = data.slice(0, loadedItemsCount);
    loadedData.forEach((item) => {
      const key = getItemKey(item);
      if (!selectedIdSet.has(key)) {
        deselectedSet.add(key);
      }
    });

    // Filter out deselected items
    return data
      .filter((item) => {
        const key = getItemKey(item);
        return !deselectedSet.has(key) && (item.PlantID || item.PLANT_FACILITY_SAP_ID) && (item.MaterialID || item.MATERIAL_TYPE_SAP_ID);
      })
      .map((x) => ({
        plantID: x.PlantID || x.PLANT_FACILITY_SAP_ID,
        materialID: x.MaterialID || x.MATERIAL_TYPE_SAP_ID,
      }));
  };

  const copyToClipboard = (sendToMrp = false, noMaxItems = false) => {
    const validityCheck = tooManyItems(noMaxItems);
    if (validityCheck.status === true) {
      if (validityCheck.type === 'mrp') setShowInfoModal({ status: true, message: 'Your amount of materials to copy is over 500.' });
      else {
        setShowInfoModal({ status: true, message: 'Your amount of materials to copy is over 500.' });
      }
      setActionMenuVisible(false);
    } else {
      const materialIds = [];
      const totalRecords = materiallistCount?.[0]?.NoofRecords || 0;

      const shouldFetchAllIds = hasSelectedAll || isSelectAllMode;

      if (shouldFetchAllIds) {
        const filterAndCopy = (allIds, sendToMrpFlag, plants, fullListData) => {
          const filteredItems = filterSelectedItems(fullListData, hasSelectedAll);
          const filteredIds = filteredItems.map((item) => item.materialID);
          const filteredPlants = filteredItems.map((item) => item.plantID);
          const filteredItemKeys = new Set(
            filteredItems.map((item) => `${item.plantID}_${item.materialID}`),
          );
          const filteredData = (fullListData || []).filter((item) => {
            const key = getItemKey(item);
            return filteredItemKeys.has(key);
          });
          copyFunction(filteredIds, sendToMrpFlag, filteredPlants, filteredData);
        };
        dispatch(allActions.MaterialListActions.getMaterialIds(materialViewState, totalRecords, sendToMrp, filterAndCopy));
      } else {
        selectedItems.forEach((element) => {
          materialIds.push(element.materialID);
        });
        const plants = selectedItems.map((item) => item.plantID);
        copyFunction(materialIds, sendToMrp, plants);
      }
    }
  };

  const handlePlannedOrder = (list) => {
    if (list.length > 150) {
      dispatch(showNotification({
        Type: 'error',
        Title: 'Large amount of data',
        Message: 'Maximum 150 materials can be selected for planned order release',
      }));
    } else {
      updatePlannedOrders(list);
      setMaterialViewState(materialViewState);
    }
  };

  const actionMenu = (
    <Menu>
      <Menu.Item key="1" onClick={() => copyToClipboard(false, true)}>
        Copy materials
      </Menu.Item>
      <Menu.Item key="2" onClick={() => copyToClipboard(true)}>
        Copy materials to mass update
      </Menu.Item>
      <Menu.Item key="4" onClick={() => setCurrentCalender(ACTIONTYPES.Inspect)}>
        {ACTIONTYPES.Inspect}
      </Menu.Item>
      <Menu.Item
        key="5"
        onClick={() => checkIfNeedConfirmation(
          ACTIONTYPES.LastChecked,
          new Date().toLocaleDateString(),
        )}
      >
        Last checked
      </Menu.Item>
      <Menu.Item
        key="3"
        onClick={() => {
          setActionMenuVisible(false);
          const totalRecords = materiallistCount?.[0]?.NoofRecords || 0;
          const shouldFetchAllIds = hasSelectedAll || isSelectAllMode;

          if (shouldFetchAllIds) {
            // Need to fetch all IDs to handle partial selection after Select All
            const filterAndHandlePlannedOrder = (allIds, sendToMrp, plants, fullListData) => {
              const filteredMaterials = filterSelectedItems(fullListData, hasSelectedAll);
              handlePlannedOrder(filteredMaterials);
            };

            dispatch(allActions.MaterialListActions.getMaterialIds(materialViewState, totalRecords, true, filterAndHandlePlannedOrder));
          } else {
            handlePlannedOrder(selectedItems);
          }
        }}
      >
        Planned order release
      </Menu.Item>
      <Menu.Item key="6" onClick={() => setCurrentCalender(ACTIONTYPES.Postpone)}>
        {ACTIONTYPES.Postpone}
      </Menu.Item>
      <Menu.Item key="7" onClick={() => checkIfNeedConfirmation(ACTIONTYPES.Review)}>
        {ACTIONTYPES.Review}
      </Menu.Item>
    </Menu>
  );

  const isMaterialMaster = location.pathname.includes('material-master');
  return (
    <>
      <Dropdown
        overlay={actionMenu}
        placement="bottomRight"
        visible={actionMenuVisible}
        disabled={isMaterialMaster || selectedItems.length === 0}
      >
        <Button
          className={styles.headerButton}
          size="middle"
          type={selectedItems.length === 0 ? 'default' : 'primary'}
          onClick={() => setActionMenuVisible(!actionMenuVisible)}
        >
          Actions
          <DownOutlined />
        </Button>
      </Dropdown>

      <CalendarModal
        visible={calenderVisible}
        onOK={currentCalender.onOK}
        onCancel={currentCalender.onCancel}
        text={currentCalender.text}
      />
      <ConfirmModal
        title="Too many items selected"
        visible={showInfoModal?.status}
        message={showInfoModal?.message}
        okButtonDisabled
        onCancel={() => setShowInfoModal({ status: false, message: '' })}
      />
      <ConfirmModal
        title="Large amount of data"
        visible={showPopup}
        message="Your amount of materials to update is over 1000. Are you sure you want to continue?"
        okButtonDisabled={false}
        onCancel={() => setShowPopup(false)}
        onOK={() => handleAction(dataToSend.actionType, dataToSend.date, true)}
      />
      <InfoModal
        visible={showInfoMsg}
        title={info.title}
        content={info.msg}
        onCancel={() => setShowInfoMsg(false)}
      />
    </>
  );
};

export default ActionMenu;

ActionMenu.defaultProps = {
  materiallistCount: [],
  hasSelectedAll: false,
  isSelectAllMode: false,
};

ActionMenu.propTypes = {
  materiallistCount: PropTypes.arrayOf(PropTypes.any),
  materialViewState: PropTypes.objectOf(PropTypes.any).isRequired,
  hasSelectedAll: PropTypes.bool,
  isSelectAllMode: PropTypes.bool,
  updateCallback: PropTypes.func.isRequired,
  loadedItemsCount: PropTypes.number.isRequired,
};
